import { lazy } from 'react';

import Loadable from 'ui-component/Loadable';

const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/authentication/Login')));

const AuthenticationRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <AuthLogin />
    },
    {
      path: '/login',
      element: <AuthLogin />
    },
    {
      path: '/*',
      element: <AuthLogin />
    }
  ]
};

export default AuthenticationRoutes;
